import type { PlayerSeasonStatRow } from '../../services/player/playerSeasonStats'

// The Penalty Minutes stat's abbreviation in the season-stats response.
const PIM_ABBR = 'PiM'

/**
 * Total penalty minutes across every team/season row: sum the `PiM` stat. The
 * value is stringified in the API; non-numeric/missing entries count as 0.
 */
export const getPenaltyMinutesTotal = (rows: PlayerSeasonStatRow[]): number => {
  let total = 0
  for (const row of rows ?? []) {
    for (const stat of row.stats ?? []) {
      const abbr = (stat.type?.abbr ?? stat.abbr ?? '').trim()
      if (abbr !== PIM_ABBR) {
        continue
      }
      const n = Number((stat.value ?? '').trim())
      if (!Number.isNaN(n)) {
        total += n
      }
    }
  }
  return total
}
